export default __webpack_public_path__ + "static/media/icon-infusion-added-drug.76c93e5d.svg";